<div id="footer">
  <div class="footer-content">
    <div style="max-width: 450px;width: 100%;">
      <img src="assets/images/homepage/fyes-logo-white.png" alt="">
    </div>
    <div class="content-lists">
        <div class="ul-list">
          <span class="title">What we do</span>
          <span class="item link" (click)="goTo('solution/home')">Home automation</span>
          <span class="item link" (click)="goTo('solution/hotel')">Hotel automation</span>
          <span class="item link" (click)="goTo('solution/workspace')">Workspace automation</span>
          <span class="item link" (click)="goTo('equipment')">Equipment</span>
        </div>
        <div class="ul-list">
          <span class="title">Company</span>
          <span class="item link" (click)="goTo('about-us')">About us</span>
          <span class="item">Careers</span>
          <span class="item link" (click)="goToSection('projects-section')">Case studies</span>
          <span class="item link" (click)="goTo('contact')">Contact us</span>
        </div>
    </div>
  </div>

  <div class="bottom-bar">
    <span>© 2026 FYES. All rights reserved</span>
    <div class="policies">
      <span class="link" (click)="goTo('terms-of-use')">Terms & conditions</span>
    </div>
    <div class="social-icons">
      <a href="https://www.linkedin.com/company/fyes/posts/?feedView=all" target="_blank" rel="noopener noreferrer"
        aria-label="FYES on LinkedIn">
        <i class="fa-brands fa-linkedin-in fa-2x"></i>
      </a>
      <a href="https://www.facebook.com/fyes.systems/" target="_blank" rel="noopener noreferrer"
        aria-label="FYES on Facebook">
        <i class="fa-brands fa-facebook-f fa-2x"></i>
      </a>
      <a href="https://www.instagram.com/fyes.gr/" target="_blank" rel="noopener noreferrer"
        aria-label="FYES on Instagram">
        <i class="fa-brands fa-instagram fa-2x"></i>
      </a>
    </div>
  </div>
</div>